import { useRef, useState } from "react";

import { hasHttpStatus } from "@/lib/api-error";

export const customerStatusMutationLocks = new Set<string>();

export function isForbidden(error: unknown): boolean {
  return hasHttpStatus(error, 403);
}

export function mutationFailure(error: unknown, action: string): string {
  return isForbidden(error)
    ? `You do not have permission to ${action}.`
    : `Failed to ${action}.`;
}

export function useSubmissionGuard() {
  const lock = useRef(false);
  const [pending, setPending] = useState(false);

  const run = async (operation: () => Promise<void>) => {
    if (lock.current) return;
    lock.current = true;
    setPending(true);
    try {
      await operation();
    } finally {
      lock.current = false;
      setPending(false);
    }
  };

  return { pending, run };
}
